import { Box, Typography } from '@mui/material'
import { mainGreen, mainRed } from '../utils/color'

export default function ListPinItem({ line_items }) {
	const items = [
		{ id: 8, name: 'Vani (bịch)', quantity: line_items?.find((item) => item.id === 8)?.quantity || 0 },
		{ id: 9, name: 'Cafe (bịch)', quantity: line_items?.find((item) => item.id === 9)?.quantity || 0 },
		{ id: 10, name: 'B.Giò (phần)', quantity: line_items?.find((item) => item.id === 10)?.quantity || 0 },
		{ id: 16, name: 'C.Giò (phần)', quantity: line_items?.find((item) => item.id === 16)?.quantity || 0 },
	]

	return (
		<Box
			sx={{
				display: 'grid',
				gridTemplateColumns: 'repeat(2, 1fr)',
				gap: '0px 20px',
				mb: 1,
			}}>
			{items.map((item) => (
				<Box
					key={item.id}
					sx={{
						display: 'flex',
						alignItems: 'center',
						gap: '4px',
						mb: 1,
					}}>
					<Typography
						sx={{
							fontSize: '14px',
							flex: 1,
							whiteSpace: 'nowrap',
							fontWeight: 'medium',
						}}>
						{item.name}
					</Typography>
					<Box
						sx={{
							border: `1px solid ${mainGreen}`,
							borderRadius: '12px',
							width: '48px',
							height: '28px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: '16px',
							fontWeight: 'medium',
							color: item.quantity > 0 ? mainRed : undefined,
						}}>
						{item.quantity}
					</Box>
				</Box>
			))}
		</Box>
	)
}

